import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Document(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.733 1c.798 0 1.548.31 2.114.87l4.266 4.236A3.023 3.023 0 0121 8.236V20c0 1.654-1.406 3-3.134 3H6.133C4.405 23 3 21.654 3 20V4c0-1.654 1.405-3 3.133-3h7.6zm-.695 2H6.133C5.508 3 5 3.448 5 4v16c0 .552.508 1 1.133 1h11.733c.625 0 1.134-.448 1.134-1V8.644h-2.96c-1.655 0-3-1.345-3-3L13.037 3zm4.777 3.644l-2.777-2.758.001 1.759c0 .552.45 1 1 1h1.776z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoDocument = React.memo(Document);
export default MemoDocument;